export default __webpack_public_path__ + "static/media/6.1d8f2f39.png";